// extracted by mini-css-extract-plugin
export default {"Stats":"GitStats_Stats__jU2G4"};